import React, { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");  // To hold success or error messages
  const [loading, setLoading] = useState(false);  // To show loading state

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch("/api/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),  // Send the email to the backend
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Thank you for subscribing!");
      } else {
        setMessage(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-white">
      <div className="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="lg:flex lg:items-start lg:gap-8">
          <div className="mt-8 grid grid-cols-2 gap-8 lg:mt-0 lg:grid-cols-5 lg:gap-y-16">
            <div className="col-span-2">
              <div>
                <h2 className="text-2xl font-bold text-gray-900">
                  Get the latest news!
                </h2>

                <p className="mt-4 text-gray-500">
                  Get exclusive updates and expert tips in your inbox. Sign up for our newsletter now!
                </p>
              </div>
            </div>

            <div className="col-span-2 lg:col-span-3 lg:flex lg:items-end">
              <form onSubmit={handleSubmit} className="w-full">
                <label htmlFor="UserEmail" className="sr-only">Email</label>

                <div className="border border-gray-100 p-2 focus-within:ring sm:flex sm:items-center sm:gap-4">
                  <input
                    type="email"
                    id="UserEmail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="john@rhcp.com"
                    className="w-full border-none focus:border-transparent focus:ring-transparent sm:text-sm"
                    required
                  />

                  <button
                    type="submit"
                    className="mt-1 w-full bg-gray-900 px-6 py-3 text-sm font-bold uppercase tracking-wide text-white transition-none hover:bg-black sm:mt-0 sm:w-auto sm:shrink-0"
                    disabled={loading}  // Disable button while loading
                  >
                    {loading ? "Signing Up..." : "Sign Up"}
                  </button>
                </div>
              </form>

              {message && (
                <p className={`mt-4 text-sm ${message.includes("Thank you") ? 'text-green-500' : 'text-red-500'}`}>
                  {message}
                </p>
              )}
            </div>

            <div className="col-span-2 sm:col-span-1">
              <p className="font-medium text-gray-900">Services</p>

              <ul className="mt-6 space-y-4 text-sm">
                {/* <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    1on1 Test Coaching
                  </a>
                </li> */}

                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Test Analysis & Feedback
                  </a>
                </li>

                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Study Materials & Resources
                  </a>
                </li>

                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Mock Tests & Practice
                  </a>
                </li>

                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Customized Study Plans
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-span-2 sm:col-span-1">
              <p className="font-medium text-gray-900">Company</p>

              <ul className="mt-6 space-y-4 text-sm">
                <li>
                  <a
                    href="/blog/about-us"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    About Us
                  </a>
                </li>

                {/* <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Meet the Team
                  </a>
                </li> */}

                {/* <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Careers
                  </a>
                </li> */}
{/* 
                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Partners & Affiliates
                  </a>
                </li> */}
              </ul>
            </div>

            <div className="col-span-2 sm:col-span-1">
              <p className="font-medium text-gray-900">Helpful Links</p>

              <ul className="mt-6 space-y-4 text-sm">
                <li>
                  <a
                    href="/blog/contact-us"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Contact
                  </a>
                </li>

                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    FAQs
                  </a>
                </li>

                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Live Chat
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-span-2 sm:col-span-1">
              <p className="font-medium text-gray-900">Legal</p>

              <ul className="mt-6 space-y-4 text-sm">
                {/* <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Accessibility
                  </a>
                </li> */}
{/* 
                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Returns Policy
                  </a>
                </li> */}

                <li>
                  <a
                    href="/blog/refund-policy"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Refund Policy
                  </a>
                </li>

                <li>
                  <a
                    href="/blog/privacy-policy"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-span-2 sm:col-span-1">
              <p className="font-medium text-gray-900">Downloads</p>

              <ul className="mt-6 space-y-4 text-sm">
                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Test Prep Calendar
                  </a>
                </li>

                <li>
                  <a
                    href="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Study Guides & Worksheets
                  </a>
                </li>
              </ul>
            </div>

            <ul className="col-span-2 flex justify-start gap-6 lg:col-span-5 lg:justify-end">
              <li>
                <a
                  href="/"
                  rel="noreferrer"
                  target="_blank"
                  className="text-gray-700 transition hover:opacity-75"
                >
                  <span className="sr-only">Facebook</span>

                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="/"
                  rel="noreferrer"
                  target="_blank"
                  className="text-gray-700 transition hover:opacity-75"
                >
                  <span className="sr-only">Instagram</span>

                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2.163c3.338 0 6.462 2.686 6.462 6.002 0 3.314-3.124 6.005-6.462 6.005-3.338 0-6.462-2.687-6.462-6.005 0-3.316 3.124-6.002 6.462-6.002zM12 0C5.373 0 0 5.358 0 12c0 3.57 2.397 6.797 5.659 8.283V24h5.723v-7.134h-1.89V12h1.89v-3.35c0-2.507 1.483-4.017 3.846-4.017 1.125 0 2.271.196 2.271.196v2.352h-1.203c-1.231 0-1.567.798-1.567 1.626v2.22h3.773l-.5 3.134h-3.276v7.115h5.578C21.608 18.798 24 15.57 24 12c0-6.642-5.373-12-12-12z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="/"
                  rel="noreferrer"
                  target="_blank"
                  className="text-gray-700 transition hover:opacity-75"
                >
                  <span className="sr-only">Twitter</span>

                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M22 5.034c-.81.36-1.684.604-2.597.713.934-.556 1.648-1.436 1.98-2.483-.873.519-1.842.9-2.87 1.104-.85-.908-2.059-1.473-3.396-1.473-2.567 0-4.646 2.08-4.646 4.646 0 .365.04.72.12 1.06-3.87-.194-7.31-2.047-9.607-4.864-.402.688-.634 1.485-.634 2.338 0 1.616.823 3.042 2.078 3.876-.767-.025-1.497-.235-2.128-.586v.059c0 2.263 1.607 4.154 3.742 4.58-.39.106-.8.165-1.21.165-.296 0-.586-.028-.874-.085.586 1.826 2.29 3.15 4.303 3.19-1.57 1.232-3.543 1.96-5.672 1.96-.366 0-.728-.021-1.085-.065 1.999 1.28 4.384 2.02 6.946 2.02 8.33 0 12.898-6.913 12.898-12.898 0-.196-.004-.391-.012-.585.89-.643 1.665-1.448 2.29-2.354z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="py-4 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} PrepNexis. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
